module.exports = __webpack_public_path__ + "img/gossip-give.83bf53df.png";